import React from 'react';

const SettingsPage = () => {
  return (
    <div>
      <h1>Settings</h1>
      {/* Settings content goes here */}
    </div>
  );
};

export default SettingsPage;
